import { StyledAreaChart } from '@/components';
import Section from '@/components/atoms/Section/Section';
import React, { FC, memo, ReactNode } from 'react';
interface ChartingData {
  value: number;
  time: string;
  label: string;
}
interface Props {
  chartingData: ChartingData[];
  startAtZero?: boolean;
  className?: string;
  yAxisType?: 'usd' | 'token' | 'percentage';
  tokenTicker?: string;
  xAxisLabels?: string[];
  yAxisLabels?: string[];
  title?: React.ReactNode;
  headerRightNode?: ReactNode;
  chartHeight?: number;
  chartMinHeight?: number;
  chartMaxHeight?: number;
  noDataNode?: React.ReactNode;
  chartId: string;
  chartColor?: string;
  extraContent?: ReactNode;
  isBackgroundTransparent?: boolean;
  isFullBleed?: boolean;
}
const ChartSection: FC<Props> = ({
  chartingData,
  startAtZero = false,
  className = '',
  yAxisType = 'usd',
  tokenTicker,
  xAxisLabels,
  yAxisLabels,
  title,
  headerRightNode,
  chartHeight,
  chartMinHeight,
  chartMaxHeight,
  noDataNode,
  chartId,
  chartColor,
  extraContent,
  isBackgroundTransparent = false,
  isFullBleed = false,
}) => {
  return (
    <Section
      headerTitle={title || ''}
      headerRightNode={headerRightNode}
      body={
        <div className="flex flex-col w-full gap-md">
          <StyledAreaChart
            data={chartingData}
            startAtZero={startAtZero}
            className={className}
            yAxisType={yAxisType}
            tokenTicker={tokenTicker}
            xAxisLabels={xAxisLabels}
            yAxisLabels={yAxisLabels}
            chartHeight={chartHeight}
            chartMinHeight={chartMinHeight}
            chartMaxHeight={chartMaxHeight}
            chartId={chartId}
            chartColor={chartColor}
            noDataNode={noDataNode}
          ></StyledAreaChart>
          {chartingData && chartingData.length > 0 && extraContent}
        </div>
      }
      isBackgroundTransparent={isBackgroundTransparent}
      isFullBleed={isFullBleed}
    />
  );
};
export default memo(ChartSection);
